import { Model, Types } from '~app/core/model';
import Position from './Position';

const graphModelMap = {
  graph: 'graph',
  conceptual: 'conceptual',
  causal: 'causal',
};

const commonFields = {
  type: Types.STR(),
  hint: Types.STR(),
  position: Types.MODEL(Position),
  hasError: Types.TRANSIENT(),
};

const flowFields = {
  connectFrom: Types.STR(),
  connectTo: Types.STR(),
  arrowHeadPosition: Types.MODEL(Position),
  arrowTailPosition: Types.MODEL(Position),
  hasSourceError: Types.TRANSIENT(),
  hasSinkError: Types.TRANSIENT(),
};

const validators = [
  obj =>
    Model.getType(obj).modelName !== 'DiagramNode'
      ? [true]
      : [false, 'invalid-type', { type: obj.type }],
  obj =>
    (!obj.connectFrom && !obj.connectTo) || obj.type === 'flow'
      ? [true]
      : [false, 'invalid-flow-key'],
  (obj, sfm) =>
    !obj.connectFrom || sfm.labelsAsSet.has(obj.connectFrom)
      ? [true]
      : [false, 'no-such-label', { label: obj.connectFrom }],
  (obj, sfm) =>
    !obj.connectTo || sfm.labelsAsSet.has(obj.connectTo)
      ? [true]
      : [false, 'no-such-label', { label: obj.connectTo }],
  obj =>
    !obj.connectTo || obj.connectTo !== obj.connectFrom
      ? [true]
      : [false, 'same-from-to'],
  (obj, sfm) =>
    !graphModelMap[sfm.type] || obj.type === 'generic'
      ? [true]
      : [false, 'incorrect-node-type-for-document-type'],
  (obj, sfm) =>
    graphModelMap[sfm.type] || obj.type !== 'generic'
      ? [true]
      : [false, 'incorrect-node-type-for-document-type'],
];

const commonMethods = {
  getIsValid(sfm) {
    for (const v of validators) {
      const [result, ...err] = v(this, sfm);
      if (!result) {
        return [result, ...err];
      }
    }
    return [true];
  },
};

const DiagramNode = Model.createType({
  name: 'DiagramNode',
  meta: {
    polymorphicOn: 'type',
    polymorphicMap: {},
  },
  fields: {
    ...commonFields,
    ...flowFields,
  },
  ...commonMethods,
});

function createType({ type, fields, properties, ...methods }) {
  const RecordType = Model.createType({
    fields: {
      ...commonFields,
      type: {
        ...commonFields.type,
        default: type,
      },
      ...fields,
    },
    meta: {
      Type: type,
      type,
    },
    properties: {
      ...properties,
    },
    ...commonMethods,
    ...methods,
  });

  DiagramNode.polymorphicMap[type] = RecordType;
  return RecordType;
}

const Unassigned = createType({
  name: 'UnassignedNode',
  type: 'unassigned',
  fields: {},
});

const Flow = createType({
  name: 'FlowNode',
  type: 'flow',
  fields: {
    ...flowFields,
  },
});

const Stock = createType({
  name: 'StockNode',
  type: 'stock',
  fields: {},
});

const Variable = createType({
  name: 'VariableNode',
  type: 'variable',
  fields: {},
});

const Generic = createType({
  name: 'GenericNode',
  type: 'generic',
  fields: {},
});

Object.assign(DiagramNode, {
  Unassigned,
  Flow,
  Stock,
  Variable,
  Generic,
});

export default DiagramNode;
